import React, { useState, useEffect } from "react";
import { Redirect } from "react-router";
import {
  useLocation,
} from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import Button from "@material-ui/core/Button";
import TableRow from "@material-ui/core/TableRow";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Colors from "../../Global/colors";
import LightButton from "../../Global/LightButton";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DarkButton from "../../Global/DarkButton";
import moment from "moment";
import GlobalApi from "../../Global";
import refresh_token from "../../Global/refresh_token";
import Sidebar from "../templateTools/tem-sidebar";
import swal from "@sweetalert/with-react";
import InputAdornment from "@material-ui/core/InputAdornment";
import Spinner from "../../Global/Spinner";
import list from "../../Assets/list.png";
import NoRecords from "../../Global/NoRecords";
import listSelected from "../../Assets/listSelected.png";
import placeholder from "../../Assets/placeholder.jpg";
import grid from "../../Assets/grid.png";
import gridSelected from "../../Assets/gridSelected.png";
import search from "../../Assets/search.png";
import NoRecord from "../../Global/NoRecords";
import {useTranslation} from 'react-i18next';
import "./publicTemplates.css";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import Chart from "react-apexcharts";
import { useSelector, useDispatch } from "react-redux";
import help from '../../Assets/help_icon.png';
import helpAr from "../../Assets/help_icon_ar.png";
import { addIndustry } from "../../Redux/Actions/industryAction";


const useStyles = makeStyles((theme) => ({
  textField: {
    borderColor: Colors.globalColor4,
    backgroundColor: Colors.globalColor5,
    borderRadius: 5,
  },
  resize: {
    fontSize: 12,
  },
  verificationCode: {
    fontSize: 18,
    textAlign: "center",
  },
}));



function PlanYourAuditsPL() {
  let history = useHistory();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [templates, setTemplates] = useState([]);
  const [industries, setIndustries] = useState(
    useSelector((state) => state.industryArrReducer.industry)
    );
  const [token, setToken] = useState("");
  const [view, setView] = useState("grid");
  const [userFilter, setUserFilter] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentIndustry, setCurrentIndustry] = useState(
    useSelector((state) => state.industryReducer.industry)
  );
  const [packageDetails, setPackageDetails] = useState(null);
  const [templateLoader, setTemplateLoader] = useState(true);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const classes = useStyles();
  let language = useSelector((state) => state.languageReducer.language);
  let industryId = useSelector((state) => state.industryReducer.industry);
  let industryData = useSelector((state) => state.industryArrReducer.industry);

  React.useEffect(
    () => {
      if (location?.state?.Industry) {
        setCurrentIndustry(location?.state?.Industry);
      }
      return () => {
        window.history.replaceState({}, document.title);
      };
    },
    [location]
  );

  useEffect(
    () => {
      getIndustriesTemplates();
    },
    [industryData]
  );

  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };

  function getIndustriesTemplates(industry_Id) {
    setTemplateLoader(true);
   
    let data = localStorage.getItem("UserData");
    let JsonData = JSON.parse(data);
    let params = {skip:0,limit:12,industry_id:industry_Id ? industry_Id : industryId };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(
      GlobalApi + "/Template/get_all_public_templates_industries?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + JsonData.token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response from get all pubnlic >>>>>>>>>>", response);
        if (response.status === "Success") {
          setTotalTemplates(response.total_records)
          console.log("templates >>>>>>>>>>>>>>>>", response);
          setTemplates(response.data);
          setTemplateLoader(false);
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getMoreIndustriesTemplates() {
    console.log("PPPPPPPPPPPPPPPPPPPPPPPPP",industryData )
    let data = localStorage.getItem("UserData");
    let JsonData = JSON.parse(data);
    let params = {skip:templates.length, limit:12, industry_id: industryId };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(
      GlobalApi + "/Template/get_all_public_templates_industries?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + JsonData.token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response from get all pubnlic >>>>>>>>>>", response);
        if (response.status === "Success") {
          setTotalTemplates(response.total_records)
          console.log("templates >>>>>>>>>>>>>>>>", response);
          setTemplates([...templates, ...response.data]);
          setTemplateLoader(false);
        }
      })
      .catch((error) => console.log(error.message));
  }


  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    
    if (bottom) {
  
      if(templates.length < totalTemplates){
        getMoreIndustriesTemplates();
      }
    }
  };



  useEffect(() => {
    getPackageDetails();
  }, []);

  const changeIndustry = (e) => {
    console.log("Industry Value", e.target.value);
    setCurrentIndustry(e.target.value);
    dispatch(addIndustry(e.target.value));
    getIndustriesTemplates(e.target.value, token);
  };

  if (localStorage.getItem("UserData") === null) {
    return <Redirect to={"/signin"} />;
  }
  var retrievedData = localStorage.getItem("UserData");
  var data = JSON.parse(retrievedData);
  if (data.token == null) {
    return <Redirect to={"/signin"} />;
  }

  return <Grid container justifyContent="center" alignItems="center" className="scrollHidden shadow" style={{height:'68vh', backgroundColor: "white", padding: "5px 0px", borderRadius: "5px", marginTop: "0px", overflowY: "hidden", width: "100%" }}>
      <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px 5px" }}>
        <Grid container spacing={1} justify="space-between" alignItems="center">
          <Grid item xs={12} lg={4}>
            <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                    <img src={search} width={12} />
                  </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search in existing Templates")} fullWidth onChange={(e) => setSearchText(e.target.value)} variant="outlined" style={{ width: "100%", marginTop: window.innerWidth < 700 ? "10px" : 0, backgroundColor: Colors.globalColor5 }} />
          </Grid>

          <Grid item xs={12} lg={4}>
            <Select className="SelectBox" style={{ width: "100%",textAlign:language =="ar" ? "left" :"left" } // id="demo-simple-select"
              } variant="outlined" size="small" value={currentIndustry} onChange={(e) => changeIndustry(e)}>
              {industries.length > 0 && industries.map((item, index) => {
                  return <MenuItem value={item.id}>{item.title}</MenuItem>;
                })}
            </Select>
          </Grid>

          <Grid item xs={12} lg={2} style={{ display:"flex", alignItems:'center'}}>
            <img alt="grid" src={view === "grid" ? gridSelected : grid} onClick={() => setView("grid")} width="30px" height="30px" style={{ cursor: "pointer" }} />
            &emsp;
            <img src={view === "list" ? listSelected : list} alt="list" onClick={() => setView("list")} width="30px" height="30px" style={{ cursor: "pointer" }} />
            &emsp;
            <Tooltip title="Help">
 
            <img src={language == "ar" ? helpAr : help} height={25} style={{marginLeft:'5px'}}/>
 
</Tooltip>
          </Grid>
          <Grid item xs={12} lg={2} style={{ textAlign: language == "ar" ? "left" : "right",}}>
            <p className="label2" style={{ textAlign: language == "ar" ? "left" : "right", display: "inline", marginTop: 12, fontSize: 10, color: "grey", textTransform: "capitalized" }}>
              {t("showing records")} {templates.length} {t("of")} {totalTemplates}
            </p>
          </Grid>
        </Grid>
      </Grid>
      <div style={{ overflow: "hidden", padding: "10px", width: "100%" }}>
        <Grid container justifyContent="center" spacing={1} style={{ padding: "5px", width: "100%", height: "55vh", overflowY: "scroll", overflowX: "hidden" }} id="scrollSection1" onScroll={(e) => handleScroll(e)} className="scrollbarShow2">
          {templateLoader && <Grid className="loaderBox" item xs={12} justifyContent="center" alignItems="center">
              <Spinner />
            </Grid>}
          {!templateLoader && <>
              {templates.length == 0 && <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", width: "100%" }}>
                  <NoRecords />
                </div>}
              {templates.length > 0 && templates.filter((word) => word.title
                          .toLowerCase()
                          .includes(
                            searchText.toLowerCase()
                          )).map((item, index) => {
                  console.log("item>>>>>>>>VVVVVVVV", item);
                  return <>
                      {view === "grid" && <Grid item xs={12} sm={6} md={4} lg={2} xl={2} justifyContent="center" alignItems="flex-end">
                          <div className="hover" style={{ display: "inline-flex", flexDirection: "column", border: "1px solid #dadada", padding: "10px", margin: "5px", flexDirection: "column", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "center", height: "230px", borderRadius: "5px", backgroundColor: "white" }}>
                            {item.industry_obj.image ? <img src={"https://server.uraudits.com/view?Key=" + item.industry_obj.image} width={"100%"} height={"100px"} style={{ objectFit: "cover", borderRadius: "5px" }} /> : <img src={placeholder} width={"100%"} height={"100px"} style={{ objectFit: "cover", borderRadius: "5px" }} />}

                            <p className="templateName" style={{ margin: "2px 0px" }}>
                              {item.title.slice(0, 45) + (item.title.length > 45 ? "..." : "")}
                            </p>
                            <p className="templateIndustry" style={{ margin: "2px 0px", color: Colors.globalColor8 }}>
                              {item.industry}
                            </p>
                            <Sidebar id={item.id} title={item.Title} description={item.Description} isDisabled={false} />
                          </div>
                        </Grid>}

                      {view === "list" && <Grid item xs={12} sm={12} md={12} lg={12} xl={12} justifyContent="center" alignItems="center">
                          <Grid container justifyContent="center" alignItems="center" style={{ padding: "10px", margin: "0px", width: "100%", borderRadius: "5px", backgroundColor: Colors.globalColor5, border: "1px solid #dadada", verticalAlign: "middle" }}>
                            <Grid item xs={12} sm={12} md={6} lg={10} xl={10}>
                              <p className="templateName">
                              {item.title.slice(0, 45) +
                                          (item.title.length > 45
                                            ? "..."
                                            : "")}
                              </p>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={2} xl={2}>
                              <Sidebar id={item.id} title={item.Title} description={item.Description} isDisabled={false} />
                            </Grid>
                          </Grid>
                        </Grid>}
                    </>;
                })}
            </>}
        </Grid>
      </div>
    </Grid>;
}

export default PlanYourAuditsPL;
